import React, {useEffect, useState} from 'react';
import HomePageTabs from "./HomePageTabs";
import {useDispatch, useSelector} from "react-redux";
import {Select} from "antd";
import {setInstallationSelect} from "../../redux-store/globalData";
import {getInstallationsWithoutPag} from "../../redux-store/installations";
import {getAllInstallationsWithoutPag, installationsLoader} from "../../redux-store/selectors";
import {SELECTED_INSTALLATION} from "../../constants/variables";
import {fetchAllLocations} from "../../redux-store/map";
import {clearActiveAlarms} from "../../redux-store/alarms";
import {Link, Outlet, useMatches} from "react-router-dom";

const {Option} = Select

const HomePage = () => {
    const [locationSelectOptions, setLocationSelectOptions] = useState([])
    const [selectedValue, setSelectedValue] = useState(null);

    const dispatch = useDispatch()
    const loading = useSelector(installationsLoader);
    const installations = useSelector(getAllInstallationsWithoutPag);


    useEffect(() => {
        dispatch(getInstallationsWithoutPag());
        return ()=>dispatch(clearActiveAlarms());
    }, [])

    useEffect(() => {
        if(installations.length === 0) return;
        const selectItem = localStorage.getItem(SELECTED_INSTALLATION);
        const selectedData = installations?.map((item, counter) => {
            if (counter === 0){
                if(selectItem !== null && selectItem !== undefined)
                    handleLocationSelectChange(JSON.parse(selectItem))
                else
                    handleLocationSelectChange({
                        label: item.name,
                        value: item.id
                    })
            }
            return {
                value:item.id,
                label:item.name
            }
        });
        setLocationSelectOptions(selectedData);
    }, [installations]);

    useEffect(()=>{
        if(selectedValue === null) return;
        dispatch(fetchAllLocations({
            installationId:selectedValue
        }))
    },[selectedValue])
    const handleLocationSelectChange = (object) => {
        localStorage.setItem(SELECTED_INSTALLATION,JSON.stringify(object));
        setSelectedValue(object.value)
        dispatch(setInstallationSelect({
            label: object.label, value: object.value
        }))
    }
    const handleSelectChange = value =>{
        const selectedOption = locationSelectOptions.find(item=>item.value === value);
        if(selectedOption === undefined) return;
        handleLocationSelectChange(selectedOption)
    }
    return (
        <>
            <div className={"container-fluid"}>
                <div className={"row pt-3 pb-3"}>
                    <div className={"col-12 col-md-6 col-lg-6 col-xl-6"}>
                        <div className="d-flex align-items-center installation-select">
                            <label className="home-page-label">Instalacije</label>
                            <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                                {/*<Controller*/}
                                {/*    control={control}*/}
                                {/*    name={"installation"}*/}
                                {/*    render={({*/}
                                {/*                 field: {onChange, value, ref},*/}
                                {/*             }) => (<Select*/}
                                {/*        onChange={onChange}*/}
                                {/*        value={value}*/}
                                {/*        ref={ref}*/}
                                {/*       style={{width:"200px"}}*/}
                                {/*        getPopupContainer={node => node.parentNode}*/}
                                {/*        disabled={loading}*/}
                                {/*        loading={loading}*/}
                                {/*    >*/}
                                {/*        {locationSelectOptions.map(item=><Option value={item.value} key={item.value}>{item.label}</Option>)}*/}
                                {/*    </Select>)}*/}
                                {/*/>*/}
                                <Select
                                    onChange={handleSelectChange}
                                    value={selectedValue}
                                    // ref={ref}
                                    style={{width:"200px"}}
                                    getPopupContainer={node => node.parentNode}
                                    disabled={loading}
                                    loading={loading}
                                >
                                    {locationSelectOptions.map(item=><Option value={item.value} key={item.value}>{item.label}</Option>)}
                                </Select>
                                {/*<Select labelInValue style={{width: "200px"}} loading={loading} disabled={loading}*/}
                                {/*        onChange={handleLocationSelectChange} value={selectedValue}>*/}
                                {/*    {locationSelectOptions}*/}
                                {/*</Select>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container-fluid home-tabs p-unset"}>
                <ul className={"nav nav-tabs map-tabs"}>
                    <li className={"nav-item"}>
                        <Link to={"/"} className={"nav-link map-nav"}>Mapa</Link>
                    </li>
                    <li className={"nav-item"}>
                        <Link to={"/map_tables"} className={"nav-link map-nav"}>Tabele</Link>
                    </li>
                    <li className={"nav-item"}>
                        <Link to={"/map_alarms"} className={"nav-link map-nav"}>Alarmi</Link>
                    </li>
                </ul>
            </div>
            <Outlet/>
        </>
    );
};

export default HomePage;
